<template>
  <v-data-table
    :headers="headers"
    :items="batches"
    :sort-by="'createdAt'"
    :sort-desc="false"
    item-key="id"
    hide-default-footer
    class="table"
    @click:row="goToBatch"
  >
    <template v-slot:item.createdAt="{ item }">
      <span>{{ item.createdAt.toDate().toLocaleString() }}</span>
    </template>
  </v-data-table>
</template>

<script>
import firebase from "firebase/app";
import _map from "lodash/map";

const headers = [
  { text: "Batch ID", value: "id" },
  { text: "Date", value: "createdAt" },
  { text: "Tester", value: "tester" }
];

export default {
  data() {
    return {
      batches: [],
      headers,
      items: [],
      filter: ""
    };
  },

  async created() {
    const db = firebase.firestore();

    try {
      const snapshot = await db
        .collection("batches")
        .where("status", "==", "INPROGRESS")
        .orderBy("createdAt", "desc")
        .get();
      this.batches = _map(snapshot.docs, doc => ({
        doc: doc.id,
        ...doc.data()
      }));
    } catch (err) {
      console.log(err);
    }
  },

  methods: {
    goToBatch(row) {
      this.$router.push({ name: "Batch", params: { batchId: row.id } });
    }
  }
};
</script>
